export default "__VITE_ASSET__ya0hj1As__"